export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑产品',
    icon: 'el-icon-edit',
    menuType: 'edit',
    allow: 'M',
  },
  {
    text: that.$l('menu_text_available') || '恢复售卖',
    icon: 'el-icon-check',
    menuType: 'available',
    divided: true,
    allow: 'N',
    disabled: ({ hxSkuPlatformStatus }) => hxSkuPlatformStatus != 'S',
  },
  {
    text: that.$l('menu_text_unsaleable') || '停售产品',
    icon: 'el-icon-close',
    menuType: 'unsaleable',
    allow: 'S',
    disabled: ({ hxSkuPlatformStatus }) => hxSkuPlatformStatus != 'Y',
  },
]
